import axios from '../utils/axios';

export default function fetchLeadsByIntegrations(adminId,integrationId,params) {
    return (
        axios.get('/admin/' + adminId +'/courses/integrations/'+ integrationId+'/leads',  {params} )
    )
}